import React, { useState, useEffect, useRef } from "react";
import * as _ from "lodash";
import "../../Invs/AFReadyDisigen/invoiceprint.css"
import { stylePadding, stylePaddingFooter, stylePaddingHead, WaterMarkName } from "../../Invs/ShareFunctionsPrint";
import Header from "./A4/Header";
import Body, { TotalsInvSearch } from "./A4/Body";
import FooterA from "../../Safes/Jard/A4/FooterA";

function HeadersNew(props) {
    const { found ,infoData} = props;
    return (
        <div style={stylePaddingHead}>
            <Header info={found}infoData={infoData}/>
        </div>
    );
}
function BodyPrint(props) {
    const { chunk, isLast,infoData } = props;
    return (
        <div style={stylePadding}>
            <Body
                data={chunk ?? []}
                infoData={infoData}
                isLast={isLast}
            />
        </div>
    );
}

function Footers(props) {
    const { found } = props;
    return (
        <div className="footerview" style={stylePaddingFooter}>
            <FooterA found={found} />
        </div>
    );
}

function InvSearchPrintCon(props) {
    const { info, dataAccounts, typePrint } = props;
    const headerRef = useRef(null);
    const footerRef = useRef(null);
    const totalsRef = useRef(null);
    const rowRefs = useRef([]);
    const [pages, setPages] = useState([]);

    useEffect(() => {
        const calcutepages = async () => {
            if (document.fonts) await document.fonts.ready;
            const PAGE_HEIGHT = 1120;
            const HEADER1 = headerRef.current?.offsetHeight || 0;
            const FOOTER1 = footerRef.current?.offsetHeight || 0;
            const TOTALSR = totalsRef.current?.offsetHeight || 0;
            const heights = rowRefs.current.map(el => el?.offsetHeight || 0);
            let maxHightsAll = PAGE_HEIGHT - (HEADER1 + FOOTER1);

            const max_HeightFirst = PAGE_HEIGHT - (HEADER1 + FOOTER1);
            const max_HeightOnther = PAGE_HEIGHT - (FOOTER1);
            let pageInvoice = [];
            let currentPage = [];
            let currentHeight = 0;

            dataAccounts.data.forEach((item, i) => {
                const rowHieght = heights[i];
                maxHightsAll = pageInvoice.length === 0 ? max_HeightFirst : max_HeightOnther;
                if (currentHeight + rowHieght > maxHightsAll) {
                    pageInvoice.push(currentPage);
                    currentPage = [];
                    currentHeight = 0;
                }
                currentPage.push(item);
                currentHeight += rowHieght;
            });

            if (currentHeight + TOTALSR > maxHightsAll) {
                pageInvoice.push(currentPage);
                pageInvoice.push([]);
            } else {
                pageInvoice.push(currentPage);
            }
            setPages(pageInvoice);
        };
        calcutepages();
    }, [dataAccounts]);
    
  const newData = dataAccounts.data.map((row, i) => {
    return {
      ...row,
      paid:dataAccounts.printKind == 1? (parseFloat(row.cash_part) + parseFloat(row.network_part) + parseFloat(row.bank_part))?.toFixed(2):
      parseFloat(row?.paid).toFixed(2) ,
      Sum_pay:parseFloat(row?.Sum_pay).toFixed(2),
      agel_part: parseFloat(row?.agel_part).toFixed(2),
      Sum_pay: parseFloat(row?.Sum_pay).toFixed(2),
      inv_type: row.inv_type == 1 ? "اجل" : "نقدي",
      netAmount: parseFloat(row?.netAmount).toFixed(2),
      AllocatedPayment: parseFloat(row?.AllocatedPayment).toFixed(2),
    };
  });

    return (
        <>
            <div className="measurecon" >
                <div ref={headerRef}>
                    <HeadersNew found={info} infoData={dataAccounts} />
                </div>
                {dataAccounts.data.map((item, i) => (
                    <div key={i}
                        ref={(el) => (rowRefs.current[i] = el)}
                        className="measurerow3"
                    >
                        { dataAccounts.printKind==1 ?  item.customer_name:item.cust_name}
                    </div>
                ))}
                <div ref={totalsRef}>
                    {<TotalsInvSearch data={ newData} infoData={dataAccounts}/>}
                </div>
                <div ref={footerRef}>
                    <Footers found={info}/>
                </div>
            </div>
            <div className="invoicepreview">
                {pages.map((page, i) => (
                    <div className="pageinv" key={i}>
                        <WaterMarkName found={info} />
                        <div className="contentview">
                            {i == 0 && (
                                <HeadersNew found={info} infoData={dataAccounts}/>
                            )}
                            <BodyPrint chunk={page ?? []} isLast={i == pages.length - 1} infoData={dataAccounts} />
                            {i==pages.length - 1&& <TotalsInvSearch data={newData} infoData={dataAccounts}/>}
                        </div>
                        <Footers found={info} />
                    </div>
                ))}
            </div>
        </>
    );
}
export default InvSearchPrintCon;
